const baseStyle = {};
const defaultProps = {
    size: 'page',
    variant: 'lightBackground'
};
const parts = ['container', 'circle', 'text'];
const sizes = {
    xs: {
        circle: {
            borderWidth: 1,
            h: 16,
            w: 16
        }
    },
    sm: {
        circle: {
            borderWidth: 2,
            h: 24,
            w: 24
        }
    },
    md: {
        circle: {
            borderWidth: 3,
            h: 32,
            w: 32
        }
    },
    lg: {
        circle: {
            borderWidth: 3,
            h: 40,
            w: 40
        }
    },
    card: {
        circle: {
            borderWidth: 4,
            h: 60,
            w: 60
        }
    },
    page: {
        circle: {
            borderWidth: 5,
            h: 80,
            w: 80
        }
    }
};
const variants = {
    lightBackground: {
        circle: {
            borderColor: 'seaBlue.80',
            borderTopColor: 'seaBlue.main'
        },
        text: {
            color: 'seaBlue.main'
        }
    },
    darkBackground: {
        circle: {
            borderColor: 'digiGreen.30',
            borderTopColor: 'digiGreen.78'
        },
        text: {
            color: 'digiGreen.78'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
